<template>
	<div>
		<!-- Tabela ativa -->
		<table
			v-if="input.type == 'table' && !input.disabled"
			class="table table-striped table-hover"
		>
			<thead>
				<tr>
					<th
						class="no-padding"
						v-for="(th, index) in options"
						:key="index"
					>
						<input
							type="text"
							:placeholder="th.text"
							v-model="th.value"
							@keyup.enter="addLine"
							class="form-control form-control-in-table"
						/>
					</th>
					<th class="text-right">
						<button class="btn btn-success btn-xs" @click="addLine">
							<i class="fa fa-plus"></i>
						</button>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, id) in input.value" :key="id">
					<td
						v-for="(col, index) in row"
						:key="index"
						class="no-padding"
					>
						<input
							type="text"
							v-model="col.value"
							class="form-control form-control-in-table"
						/>
					</td>
					<td class="text-right">
						<button
							class="btn btn-danger btn-xs"
							@click="deleteRow(id)"
						>
							<i class="fa fa-trash"></i>
						</button>
					</td>
				</tr>

				<tr v-if="input.value != undefined && input.value.length == 0">
					<td :colspan="options.length + 1">
						Nenhum registro encontrado!
					</td>
				</tr>
			</tbody>
		</table>

		<!-- Tabela Desativa -->
		<!-- <table v-if="input.type == 'table' && input.disabled"  class="table table-striped">
			<thead>
				<tr>
					<th v-for="(th, index) in options" :key="index">
						{{th.text}}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, id) in values">
					<td v-for="(col, index) in row" :key="index">
						{{col.value}}
					</td>
				</tr>

				<tr v-if="values.length == 0">
					<td :colspan='options.length + 1'>Nenhum registro encontrado!</td>
				</tr>
			</tbody>
		</table> -->
		<!-- <pre>{{values}}</pre> -->
	</div>
</template>
<script>
	import clone from 'js/clone';
	export default {
		name: 'ChTable',
		props: ['data'],
		data() {
			return {
				colls: [],
			};
		},
		computed: {
			input() {
				return this.data;
			},
			options() {
				this.colls = [];
				if (typeof this.input.options.options == 'object') {
					this.input.options.options.forEach((item, id) => {
						this.colls.push({
							coll: item.value,
							value: '',
							text: item.text,
						});
					});
				}
				return clone(this.colls);
			},

			values() {
				if (typeof this.input.value == 'object') {
					return this.input.value;
				} else {
					return [];
				}
			},
		},
		methods: {
			addLine() {
				if (this.input.value == undefined || this.input.value == '')
					this.input.value = [];
				this.input.value.push(clone(this.options));
				this.colls = clone(this.colls);
			},
			deleteRow(id) {
				this.input.value.splice(id, 1);
			},
		},
	};
</script>
<style scoped>
	.form-control-in-table {
		background: none;
		border: none;
		padding: 5px;
		width: 100%;
	}
	.radio {
		margin-bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/inputs/table.vue